export const DashboardDoctor = {
  fr: {
    title: "Mon Tableau de bord",
    WeAreOn: "Nous sommes le ",
    Rest: "Réinitialiser",
    NewWidget: "+ Nouveau widget",
    ConsultationOf: "Consultation du",
    Report: "Compte rendu",
    Prescription: "Prescription",
    CardCPSTitle: "Ma carte CPS",
    Info: "Mes informations",
    nationalId: "Identifiant national",
    cardId: "Identifiant de la carte",
    Name: "Nom",
    FirstName: "Prénom",
    IssuedOn: "Émise le",
    Survey: "Enquêtes",
    NoSurveyFound: "Aucun questionnaire trouvé",
    lastUpdate: "Dernière modification apportée le",
    taskOfDay: "Taches du jour",
    Agenda: "Agenda",
    today: "Aujourd'hui",
    EmptyList: "La liste de rendez-vous est vide",
    EmptyTask: "Aucune tâche aujourd'hui",
    EmptyConsultation: "Aucune consultation aujourd'hui",
    ptientofDay: "Patients du jour",
    connected: "Vous êtes maintenant connecté",
    noActiveStudy: "Aucune étude trouvée",
    noArchiveStudy: "Aucune étude archivée trouvée",
  },

  en: {
    title: "Dashboard",
    WeAreOn: "We are on ",
    Reset: "Reset",
    NewWidget: "+ New widget",
    ConsultationOf: "Consultation of",
    Report: "Report",
    Prescription: "Prescription",
    CardCPSTitle: "My CPS card",
    Info: "My information",
    nationalId: "National ID",
    cardId: "Card ID",
    Name: "Name",
    FirstName: "First name",
    IssuedOn: "Issued on",
    Survey: "Enquêtes",
    NoSurveyFound: "No survey found",
    lastUpdate: "Last modification made on",
    taskOfDay: "Tasks of the day",
    Agenda: "Agenda",
    today: "Today",
    EmptyList: "The meet list is empty",
    EmptyTask: "No task today",
    EmptyConsultation: "No consultation today",
    ptientofDay: "Patients of the day",
    connected: "You are now connected",
    noActiveStudy: "No study found",
    noArchiveStudy: "No archived studies found",
  },
};
